// extracted by mini-css-extract-plugin
export var icon = "TimelineItem-module--icon--06244";
export var title = "TimelineItem-module--title--64a8c";
export var wrapper = "TimelineItem-module--wrapper--29b16";